import { QueryParamService } from './services/queryParamService';

window.onload = function () {
  const queryParamService = new QueryParamService();
  queryParamService.saveQueryParam('ihc-providers', 'ihc-providers');
  const findAlabWidget = document.querySelector('#FindaLabMenuBtn');

  if (findAlabWidget) {
    /** Get the find a lab widget parent <li> element and remove class to not show dropdown */
    findAlabWidget.parentElement.classList.remove('is-dropdown-submenu-parent');
  }

  const handleFindALabViewClick = function () {
    const navItem = $(this);
    const findALabContainer = $('div.findALabContainer.findalab-container-mobile');
    const findALabMap = $('div.findALabMap');
    const mapViewClass = 'map-view';

    if (navItem.text().indexOf('Map View') != -1) {
      findALabContainer.addClass(mapViewClass);
      findALabMap.addClass(mapViewClass);
      return;
    }

    findALabContainer.removeClass(mapViewClass);
    findALabMap.removeClass(mapViewClass);
  };

  $(document).on('click', '.findalab__nav__item', handleFindALabViewClick);
};
